export var shouldRel = href => typeof href === 'string' && href.startsWith("") ? "noopener noreferrer" : undefined;
//# sourceMappingURL=utils.js.map